// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36pkv","placeholdersHeader":"styles_placeholdersHeader__3sgSy","editorStyle":"styles_editorStyle__1ZuQ5","placeholdersBox":"styles_placeholdersBox__37rTo"};